import { render, staticRenderFns } from "./el-descriptions.vue?vue&type=template&id=2d71498c&scoped=true"
import script from "./el-descriptions.vue?vue&type=script&lang=js"
export * from "./el-descriptions.vue?vue&type=script&lang=js"
import style0 from "./el-descriptions.vue?vue&type=style&index=0&id=2d71498c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d71498c",
  null
  
)

export default component.exports